var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddSdk(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 9.686,
    height: 10,
    viewBox: "0 0 9.686 10",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "be9d19a44d5f79eebf2365b5e43e0416",
    transform: "translate(-10 -71.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11392",
    "data-name": "Path 11392",
    d: "M19.724,454a.405.405,0,0,0-.174.041h0L15.339,456.1l-4.211-2.057h0a.382.382,0,0,0-.173-.041.5.5,0,0,0-.454.536.542.542,0,0,0,.281.495l4.384,2.142h0a.383.383,0,0,0,.173.041.4.4,0,0,0,.173-.041h0l4.384-2.142a.547.547,0,0,0,.281-.5.5.5,0,0,0-.454-.536Z",
    transform: "translate(-0.494 -378.037)",
    fill: "#363a4a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11393",
    "data-name": "Path 11393",
    d: "M10.281,74.672h0l4.384,2.142h0a.382.382,0,0,0,.173.041.394.394,0,0,0,.173-.041h0L19.4,74.672a.576.576,0,0,0,0-.99h0l-4.383-2.141h0a.382.382,0,0,0-.173-.041.4.4,0,0,0-.173.041h0l-4.385,2.142a.575.575,0,0,0,0,.988Z",
    transform: "translate(0)",
    fill: "#363a4a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11394",
    "data-name": "Path 11394",
    d: "M19.625,653.1a.405.405,0,0,0-.174.041h0L15.24,655.2l-4.211-2.056h0a.382.382,0,0,0-.173-.041.5.5,0,0,0-.455.536.542.542,0,0,0,.281.495l4.384,2.141h0a.383.383,0,0,0,.173.041.394.394,0,0,0,.173-.041h0L19.8,654.13a.543.543,0,0,0,.281-.495.5.5,0,0,0-.454-.536Z",
    transform: "translate(-0.395 -574.813)",
    fill: "#363a4a"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddSdk);
export default __webpack_public_path__ + "static/media/addSdk.b89694a1.svg";
export { ForwardRef as ReactComponent };